import * as GarageVisitsModels from '../../models/garage-visits/garage-visits';
import * as Models from '../../models/commonModels';

export class GetGarageVisitPlaceList {
  static readonly type = '[GarageVisits]  GetGarageVisitPlaceList';
  constructor(public Search: GarageVisitsModels.GarageVisitsPlaceSearch) { }
}

export class GarageVisitPlaceRefresh {
  static readonly type = '[GarageVisits] GarageVisitPlaceRefresh';
  constructor(public Search: GarageVisitsModels.GarageVisitsPlaceSearch) { }
}

export class SetGarageVisitPlace {
  static readonly type = '[GarageVisits] SetGarageVisitPlace';
  constructor(public GaragePlace: Models.Request<GarageVisitsModels.GarageVisitsPlaceModel>) { }
}

export class RemoveGarageVisitPlace {
  static readonly type = '[GarageVisits] RemoveGarageVisitPlace';
  constructor(public GaragePlace: Models.Request<GarageVisitsModels.GarageVisitsPlaceModel>) { }
}

export class GetGarageVisitPlace {
  static readonly type = '[GarageVisits] GetGarageVisitPlace';
  constructor(public GaragePlace: Models.RequestModel) { }
}

export class SetGarageVisitPlaceSearch {
  static readonly type = '[GarageVisits] SetGarageVisitPlaceSearch';
  constructor(public Search: GarageVisitsModels.GarageVisitsPlaceSearch) { }
}

export class ResetGarageVisitPlaceSearch {
  static readonly type = '[GarageVisits] ResetGarageVisitPlaceSearch';
  constructor() { }
}

export class SetGarageVisitPlaceListPage {
  static readonly type = '[GarageVisits] SetGarageVisitPlaceListPage';
  constructor(public Search: GarageVisitsModels.GarageVisitsPlaceSearch) { }
}


export class GetGarageBlockedHourList {
  static readonly type = '[GarageVisits]  GetGarageBlockedHourList';
  constructor(public Search: GarageVisitsModels.GarageBlockedHourSearch) { }
}

export class SetGarageBlockedHour {
  static readonly type = '[GarageVisits] SetVisitBlockedHour';
  constructor(public Set: Models.Request<GarageVisitsModels.GarageBlockedModel>) { }
}

export class RemoveGarageBlockedHour {
  static readonly type = '[GarageVisits] RemoveVisitBlockedHour';
  constructor(public Remove: Models.Request<GarageVisitsModels.GarageBlockedModel>) { }
}


export class GetGarageBlockedDaysList {
  static readonly type = '[GarageVisits]  GetGarageBlockedDaysList';
  constructor(public Search: GarageVisitsModels.GarageBlockedHourSearch) { }
}

export class SetGarageBlockedDay {
  static readonly type = '[GarageVisits] SetGarageBlockedDay';
  constructor(public Set: Models.Request<GarageVisitsModels.GarageBlockedModel>) { }
}

export class RemoveGarageBlockedDay {
  static readonly type = '[GarageVisits] RemoveGarageBlockedDay';
  constructor(public Remove: Models.Request<GarageVisitsModels.GarageBlockedModel>) { }
}




export class GetGarageVisitList {
  static readonly type = '[GarageVisits] GetGarageVisitList';
  constructor(public Search: GarageVisitsModels.GarageVisitsSearchModel) { }
}

export class GetGarageMainVisitList {
  static readonly type = '[GarageVisits] GetGarageMainVisitList';
  constructor(public Search: GarageVisitsModels.GarageVisitsSearchModel) { }
}

export class SetGarageVisitsSearch {
  static readonly type = "[GarageVisits] SetGarageVisitsSearch";
  constructor(public Search: GarageVisitsModels.GarageVisitsSearchModel) { }
}

export class DisposeGarageVisitsSearch {
  static readonly type = '[GarageVisits] DisposeGarageVisitsSearch';
  constructor() { }
}


export class SetGarageVisitListPage {
  static readonly type = "[GarageVisits] SetGarageVisitListPage";
  constructor(public Search: GarageVisitsModels.GarageVisitsSearchModel) { }
}

export class ResetGarageVisitsSearch {
  static readonly type = "[GarageVisits] ResetGarageVisitsSearch";
  constructor() { }
}

export class CreateGarageVisit {
  static readonly type = '[GarageVisits] CreateGarageVisit';
  constructor(public GarageVisit: Models.Request<GarageVisitsModels.GarageVisitModel>) { }
}

export class SetGarageVisit {
  static readonly type = '[GarageVisits] SetGarageVisit';
  constructor(public GarageVisit: Models.Request<GarageVisitsModels.GarageVisitModel>) { }
}

export class GetGarageVisit {
  static readonly type = '[GarageVisits] GetGarageVisit';
  constructor(public GarageVisitId: Models.RequestModel) { }
}

export class DeleteGarageVisit {
  static readonly type = '[GarageVisits] DeleteGarageVisit';
  constructor(public GarageVisitId: Models.RequestModel) { }
}


export class GetGarageVisitFilteredPdfList {
  static readonly type = '[GarageVisits] GetGarageVisitFilteredPdfList';
  constructor(public Search: GarageVisitsModels.GarageVisitsSearchModel) { }
}

export class GetGarageVisitFilteredReportList {
  static readonly type = '[GarageVisits] GetGarageVisitFilteredReportList';
  constructor(public Search: GarageVisitsModels.GarageVisitsSearchModel) { }
}

export class GetGarageVisitPlaceFilteredPdfList {
  static readonly type = '[GarageVisits] GetGarageVisitPlaceFilteredPdfList';
  constructor(public Search: GarageVisitsModels.GarageVisitsSearchModel) { }
}
export class GetGarageVisitsCarTypeDictionary {
  static readonly type = '[GarageVisits] GetGarageVisitsCarTypeDictionary';
  constructor() { }
}
